import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/first';
import { Router, ActivatedRoute,NavigationExtras,Resolve,ActivatedRouteSnapshot,RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class SignResolver implements Resolve<any> {

  constructor(private http: HttpClient,private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    console.log('comes inside resolver',this.router.getCurrentNavigation())
    return this.router.getCurrentNavigation();
  }
}
